import { Box, Button, Typography } from '@mui/material';
import { ContextMenu } from 'components/common/ContextMenu';
import { RadioMenuItem } from 'components/common/form/Select';
import { IconLinearArrowDown } from 'components/icons/components/linear/IconLinearArrowDown';
import { IconLinearSort } from 'components/icons/components/linear/IconLinearSort';
import { getSentimentLabelBySentiment } from 'features/socialListeningAnalytics/views/slaBrandInboundSentiment/types';
import { Sentiment } from 'graphql/generated';
import { theme } from 'styles/theme';

export const DEFAULT_SENTIMENT_OPTIONS = [
  Sentiment.Negative,
  Sentiment.Neutral,
  Sentiment.Positive,
];

export type SMLFilterBySentimentButtonProps = {
  sentiment: Sentiment;
  setSentiment: (sentiment: Sentiment) => void;
  sentimentOptions?: Sentiment[];
};

// Filter component for sentiment
// Default options is [Sentiment.Negative, Sentiment.Neutral, Sentiment.Positive]
// If you want to change the options, you can pass them as a prop
export const SMLFilterBySentimentButton = ({
  sentiment,
  setSentiment,
  sentimentOptions = DEFAULT_SENTIMENT_OPTIONS,
}: SMLFilterBySentimentButtonProps) => {
  return (
    <ContextMenu
      sx={{
        '& .context-menu-item': {
          p: 0,
          color: theme.colors?.primary.black,
        },
      }}
      options={sentimentOptions.map((item) => {
        return {
          renderOption: () => (
            <RadioMenuItem
              label={getSentimentLabelBySentiment(item)}
              value={item}
              checked={sentiment === item}
              sx={{
                p: `${theme.spacing(2, 3)}`,
              }}
            />
          ),
          onClick: () => {
            setSentiment(item);
          },
        };
      })}
      renderButton={(open?: boolean) => (
        <Button
          sx={{
            backgroundColor: theme.colors?.utility[275],
            color: theme.colors?.primary.black,
            borderRadius: theme.spacing(2),
            display: 'flex',
            gap: 2,
            p: theme.spacing(1, 2),
            alignItems: 'center',
            '&:hover': {
              backgroundColor: theme.colors?.utility[275],
            },
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              backgroundColor: 'rgba(35, 6, 3, 0.05);',
              p: theme.spacing(1),
              borderRadius: theme.spacing(1),
            }}
          >
            <IconLinearSort size={16} />
          </Box>
          <Typography
            fontWeight={500}
            variant="body-xl"
            textTransform="capitalize"
          >
            {getSentimentLabelBySentiment(sentiment)}
          </Typography>
          <IconLinearArrowDown
            size={16}
            color={theme.colors?.primary.black}
            style={{
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </Button>
      )}
    />
  );
};
